export const DrawinkPlusPromoBanner = ({
  isSignedIn,
}: {
  isSignedIn: boolean;
}) => {
  return null;
  // return (
  //   <a
  //     href={
  //       isSignedIn
  //         ? "/app"
  //         : "/plus?utm_source=drawink&utm_medium=app&utm_content=guestBanner#drawink-redirect"
  //     }
  //     target="_blank"
  //     rel="noopener"
  //     className="plus-banner"
  //   >
  //     Drawink Pro
  //   </a>
  // );
};
